import { render, staticRenderFns } from "./Sobt.vue?vue&type=template&id=3f0fbfb3&scoped=true&"
import script from "./Sobt.vue?vue&type=script&lang=js&"
export * from "./Sobt.vue?vue&type=script&lang=js&"
import style0 from "./Sobt.vue?vue&type=style&index=0&id=3f0fbfb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0fbfb3",
  null
  
)

export default component.exports